// src/components/auth/OAuthCallbackStatus.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for retry/back button

interface OAuthCallbackStatusProps {
  isLoading: boolean;
  errorMsg: string | null;
  providerName: string; // To customize messages slightly
}

const OAuthCallbackStatus: React.FC<OAuthCallbackStatusProps> = ({
  isLoading,
  errorMsg,
  providerName,
}) => {
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <h1 className="text-3xl font-bold">Signing in with {providerName}...</h1>
        {/* Optional: Add a spinner component here */}
        {/* <Spinner /> */}
      </div>
    );
  }

  if (errorMsg) {
    return (
      <div className="flex flex-col items-center justify-center h-screen text-center px-4">
        <h1 className="text-xl font-bold text-red-600 mb-4">Sign-in Error</h1>
        <p className="mb-6">{errorMsg}</p>
        {/* Add a button to go back to the sign-in page */}
        <button
          onClick={() => navigate('/signin')} // Navigate back to sign-in
          className="deriq-action-button" // Use your standard button style
        >
          Back to Sign In
        </button>
      </div>
    );
  }

  // This state is usually brief as navigation happens on success,
  // but it's good to have a fallback.
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-3xl font-bold">Processing complete.</h1>
      <p>Redirecting...</p>
    </div>
  );
};

export default OAuthCallbackStatus;
